<template lang="pug">
div
  empty-container(v-if="!list.rows.length" title="Nenhuma solicitação")
  table.table.table-striped.table-hover(v-else)
    thead
      tr
        th ID
        th Situação
        th Data
        th
    tbody
      tr(v-for="item in list.rows")
        td {{item.id}}
        td(:class="item.status") {{item.status | requestStatus}}
        td {{item.createdAt | date('DD/MM/YYYY - HH:mm:ss')}}
        td.columns
          .column.col-6.tooltip.tooltip-left(data-tooltip="Visualizar solicitação")
            i.fas.fa-eye.c-hand(@click="$emit('show', item.id)")
          .column.col-6.tooltip.tooltip-left(data-tooltip="Cancelar solicitação" v-if="item.status === 'waiting'")
            i.fas.fa-times.c-hand(@click="$emit('cancel', item.id)")
</template>

<script>
export default {
  props: {
    list: { type: Object, required: true },
  },
}
</script>

<style lang="stylus" scoped>
.approved
  color green

.waiting
  color orange

.denied
  color red
</style>
